import { useTranslation } from "react-i18next"

interface ContactInfoCardProps {
  className?: string
}

export function ContactInfoCard({ className = "" }: ContactInfoCardProps) {
  const { t } = useTranslation()

  return (
    <div className={`text-sm text-slate-500 bg-slate-50 p-4 rounded-lg ${className}`}>
      <p className="font-medium mb-2">{t("common.contact")}:</p>
      <p>{t("common.company")}</p>
      <p>{t("common.email")}: contact@basciano.io</p>
      <p>
        {t("common.address")}: {t("common.fullAddress")}
      </p>
    </div>
  )
}
